package com.xtream.data_kmp.dto



import androidx.room3.Ignore
import com.xtream.data_kmp.AllConst
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonTransformingSerializer

@Serializable

data class SeriesInfo(
    @SerialName("episodes")
    val episodes: Map<String?, List<Episode>>?=null,
    @SerialName("info")
    val info: InfoBase?=null,
    @SerialName("seasons")
    val seasons: ArrayList<Season?>?=null,
    @kotlinx.serialization.Transient
    var streamId:Int?=null
) {
    @Serializable
    
    data class Season(
        @SerialName("air_date")
        val airDate: String,
        @SerialName("episode_count")
        val episodeCount: Int?,
        val id: Int,
        val name: String,
        val overview: String,
        @SerialName("season_number")
        val seasonNumber: Int,
        @SerialName("vote_average")
        val voteAverage: Double,
        val cover: String,
        @SerialName("cover_big")
        val coverBig: String
    )

        @Serializable
        
data class Episode(
            @SerialName("added")
         override   val added: String,
            @SerialName("container_extension")
            val containerExtension: String?,
            @SerialName("custom_sid")
            override  val customSid: String?,//custom_sid
            @SerialName("direct_source")
           override val directSource: String?,
            @SerialName("episode_num")
           override val num: Int?,
            @SerialName("id")
            override val streamId: Int,
            @SerialName("info", )
            @Serializable(SafeSeriesEpisodeInfoSerializer::class)
            val info: SeriesEpisodeInfo?,
            @SerialName("season")
            val season: Int?,
            @SerialName("title")
           override val name: String,

            @Deprecated("streamType is deprecated", replaceWith = ReplaceWith("type"))
            override val streamType: String= AllConst.SERIES_STREAMS,

            ):BaseStream {
            @kotlinx.serialization.Transient
            @Ignore
            override val type: StreamType=StreamType.BACKDROP
            @kotlinx.serialization.Transient
            override val categoryId: Int?=null
            @kotlinx.serialization.Transient
            override val isAdult: Int=-1
            @kotlinx.serialization.Transient
            override val streamIcon: String? =null




            @Serializable()
            
data class SeriesEpisodeInfo(

                @SerialName("bitrate")
                val bitrate: Int?,
                @SerialName("duration")
                val duration: String?,
                @SerialName("duration_secs")
                val durationSecs: Int?,

                @SerialName("plot")
                  val plot: String?

            ) {
                @kotlinx.serialization.Transient
                @SerialName("audio")
                val audio: Audio?=null

                @kotlinx.serialization.Transient
                @SerialName("video")
                val video: Video?=null
                @Serializable
                
data class Audio(
                    @SerialName("avg_frame_rate")
                    val avgFrameRate: String?,
                    @SerialName("bit_rate")
                    val bitRate: String?,
                    @SerialName("bits_per_sample")
                    val bitsPerSample: Int?,
                    @SerialName("channel_layout")
                    val channelLayout: String?,
                    @SerialName("channels")
                    val channels: Int?,
                    @SerialName("codec_long_name")
                    val codecLongName: String?,
                    @SerialName("codec_name")
                    val codecName: String?,
                    @SerialName("codec_tag")
                    val codecTag: String?,
                    @SerialName("codec_tag_string")
                    val codecTagString: String?,
                    @SerialName("codec_time_base")
                    val codecTimeBase: String?,
                    @SerialName("codec_type")
                    val codecType: String?,
                    @SerialName("disposition")
                    val disposition: Disposition?,
                    @SerialName("duration")
                    val duration: String?,
                    @SerialName("duration_ts")
                    val durationTs: Int?,
                    @SerialName("index")
                    val index: Int?,
                    @SerialName("max_bit_rate")
                    val maxBitRate: String?,
                    @SerialName("nb_frames")
                    val nbFrames: String?,
                    @SerialName("profile")
                    val profile: String?,
                    @SerialName("r_frame_rate")
                    val rFrameRate: String?,
                    @SerialName("sample_fmt")
                    val sampleFmt: String?,
                    @SerialName("sample_rate")
                    val sampleRate: String?,
                    @SerialName("start_pts")
                    val startPts: Int?,
                    @SerialName("start_time")
                    val startTime: String?,
                    @SerialName("tags")
                    val tags: Tags?,
                    @SerialName("time_base")
                    val timeBase: String?
                ) {

                    @Serializable
                    
data class Disposition(
                        @SerialName("attached_pic")
                        val attachedPic: Int?,
                        @SerialName("clean_effects")
                        val cleanEffects: Int?,
                        @SerialName("comment")
                        val comment: Int?,
                        @SerialName("default")
                        val default: Int?,
                        @SerialName("dub")
                        val dub: Int?,
                        @SerialName("forced")
                        val forced: Int?,
                        @SerialName("hearing_impaired")
                        val hearingImpaired: Int?,
                        @SerialName("karaoke")
                        val karaoke: Int?,
                        @SerialName("lyrics")
                        val lyrics: Int?,
                        @SerialName("original")
                        val original: Int?,
                        @SerialName("timed_thumbnails")
                        val timedThumbnails: Int?,
                        @SerialName("visual_impaired")
                        val visualImpaired: Int?
                    )

                    @Serializable
                    
data class Tags(
                        @SerialName("handler_name")
                        val handlerName: String?,
                        @SerialName("language")
                        val language: String?
                    )
                }

                @Serializable
                
data class Video(
                    @SerialName("avg_frame_rate")
                    val avgFrameRate: String?,
                    @SerialName("bit_rate")
                    val bitRate: String?,
                    @SerialName("bits_per_raw_sample")
                    val bitsPerRawSample: String?,
                    @SerialName("chroma_location")
                    val chromaLocation: String?,
                    @SerialName("codec_long_name")
                    val codecLongName: String?,
                    @SerialName("codec_name")
                    val codecName: String?,
                    @SerialName("codec_tag")
                    val codecTag: String?,
                    @SerialName("codec_tag_string")
                    val codecTagString: String?,
                    @SerialName("codec_time_base")
                    val codecTimeBase: String?,
                    @SerialName("codec_type")
                    val codecType: String?,
                    @SerialName("coded_height")
                    val codedHeight: Int?,
                    @SerialName("coded_width")
                    val codedWidth: Int?,
                    @SerialName("display_aspect_ratio")
                    val displayAspectRatio: String?,
                    @SerialName("disposition")
                    val disposition: Disposition?,
                    @SerialName("duration")
                    val duration: String?,
                    @SerialName("duration_ts")
                    val durationTs: Int?,
                    @SerialName("has_b_frames")
                    val hasBFrames: Int?,
                    @SerialName("height")
                    val height: Int?,
                    @SerialName("index")
                    val index: Int?,
                    @SerialName("is_avc")
                    val isAvc: String?,
                    @SerialName("level")
                    val level: Int?,
                    @SerialName("nal_length_size")
                    val nalLengthSize: String?,
                    @SerialName("nb_frames")
                    val nbFrames: String?,
                    @SerialName("pix_fmt")
                    val pixFmt: String?,
                    @SerialName("profile")
                    val profile: String?,
                    @SerialName("r_frame_rate")
                    val rFrameRate: String?,
                    @SerialName("refs")
                    val refs: Int?,
                    @SerialName("sample_aspect_ratio")
                    val sampleAspectRatio: String?,
                    @SerialName("start_pts")
                    val startPts: Int?,
                    @SerialName("start_time")
                    val startTime: String?,
                    @SerialName("tags")
                    val tags: Tags?,
                    @SerialName("time_base")
                    val timeBase: String?,
                    @SerialName("width")
                    val width: Int?
                ) {
                    @Serializable
                    
data class Disposition(
                        @SerialName("attached_pic")
                        val attachedPic: Int?,
                        @SerialName("clean_effects")
                        val cleanEffects: Int?,
                        @SerialName("comment")
                        val comment: Int?,
                        @SerialName("default")
                        val default: Int?,
                        @SerialName("dub")
                        val dub: Int?,
                        @SerialName("forced")
                        val forced: Int?,
                        @SerialName("hearing_impaired")
                        val hearingImpaired: Int?,
                        @SerialName("karaoke")
                        val karaoke: Int?,
                        @SerialName("lyrics")
                        val lyrics: Int?,
                        @SerialName("original")
                        val original: Int?,
                        @SerialName("timed_thumbnails")
                        val timedThumbnails: Int?,
                        @SerialName("visual_impaired")
                        val visualImpaired: Int?
                    )

                    @Serializable
                    
data class Tags(
                        @SerialName("handler_name")
                        val handlerName: String?,
                        @SerialName("language")
                        val language: String?
                    )
                }
            }
        }



}
object SafeSeriesEpisodeInfoSerializer :
    JsonTransformingSerializer<SeriesInfo.Episode.SeriesEpisodeInfo>(SeriesInfo.Episode.SeriesEpisodeInfo.serializer()) {
    override fun transformDeserialize(element: JsonElement): JsonElement {
        return element as? JsonObject ?: JsonObject(emptyMap()) // fallback to empty object
    }
}